import http from '@/api/http'

import {
  PostChargingStartPayload,
  PostChargingStartResponse,
  PostChargingStopPayload,
  PostChargingStopResponse,
  GetChargingStatusPayload,
  GetChargingStatusResponse,
  GetChargingHistoryResponse,
  GetChargingConfigResponse,
  GetChargingHistoryStationsResponse,
  ChargingHistoryPayload,
} from './types'

export const postChargingStart = async (payload: PostChargingStartPayload): Promise<PostChargingStartResponse> => {
  const response = await http.post<PostChargingStartResponse, PostChargingStartPayload>('/charging/start/', payload)
  return response.data
}

export const postChargingStop = async (payload: PostChargingStopPayload): Promise<PostChargingStopResponse> => {
  const { charging_point_id } = payload

  const response = await http.post<PostChargingStopResponse, PostChargingStopPayload>('/charging/stop/', {
    charging_point_id,
  })
  return response.data
}

export const getChargingConfig = async (): Promise<GetChargingConfigResponse> => {
  const response = await http.get<GetChargingConfigResponse>(`/charging/config/`)
  return response.data
}

export const getChargingStatus = async (payload: GetChargingStatusPayload): Promise<GetChargingStatusResponse> => {
  const { charging_point_id } = payload

  const response = await http.get<GetChargingStatusResponse, GetChargingStatusPayload>(
    `/charging/charging-point/${charging_point_id}/status/`
  )
  return response.data
}

export const getChargingHistory = async (payload: ChargingHistoryPayload = {}): Promise<GetChargingHistoryResponse> => {
  const { page, qnt, status, startTimeFrom, startTimeTo, stationName } = payload

  const response = await http.get<GetChargingHistoryResponse, ChargingHistoryPayload>('/charging/history/', {
    page,
    qnt,
    ...(status && { status }),
    ...(startTimeFrom && { start_time_from: startTimeFrom }),
    ...(startTimeTo && { start_time_to: startTimeTo }),
    ...(stationName && { station_name: stationName }),
  })
  return response.data
}


export const getChargingHistoryStations = async (): Promise<GetChargingHistoryStationsResponse> => {
  const response = await http.get<GetChargingHistoryStationsResponse>('/charging/history/stations/')
  return response.data
}
